import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { GridCard } from '../../../../components';

import ListOpportunityDetail from './ListOpportunityDetail';

const sanitizeRestProps = ({
  hasShow,
  hasEdit,
  hasList,
  hasCreate,
  ...props
}) => {
  return props;
};

const useStyles = makeStyles({
  headerRoot: {
    paddingBottom: 0,
  },
});

const OpportunityDetailCard = (props) => {
  const classes = useStyles();

  return (
    <GridCard
      {...sanitizeRestProps(props)}
      classes={classes}
      xs={12}
      title="Historique des opportunités"
    >
      <ListOpportunityDetail xs={12} />
    </GridCard>
  );
};

export default OpportunityDetailCard;
